import React from "react";
import styles from "./Table.module.scss";

interface TableProps<T> {
  columns: { type: string; value: string }[];
  rows: T[];
  renderCell: (column: string, row: T, rowIndex: number) => React.ReactNode;
}

const Table = <T,>({
  columns,
  rows,
  renderCell,
}: TableProps<T>): React.ReactElement => {
  return (
    <div className={styles["container"]}>
      <table dir="rtl">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.type} id={column?.type}>
                {column.value}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((column) => (
                <td key={column.type} id={column?.type}>
                  {renderCell(column.type, row, rowIndex)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default React.memo(Table);
